<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="margin-top-home">
        <div class="text-center margin-top-home">
          <img v-if="rider.stravaDetails.profile" :src="rider.stravaDetails.profile" width="60px">
          <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="40px">
          <br>
          <a :href="`https://www.strava.com/athletes/${rider.stravaAthleteId}`" target="_blank" class="strava smaller-font">View on Strava</a>
          <br>
          <h3>
            <b>{{ rider.stravaDetails.firstname }} {{ rider.stravaDetails.lastname }}</b>
          </h3>
          <br>
          <div>
            <fa-icon icon="question-circle" v-tooltip:right="`When you race, you gain Race Points based on your race ranking. Only your best attempt at a race is taken into account. The higher your race ranking at a race, the higher your Race Points. The more riders on a race, the higher the Race Points awarded to top riders.`" />
            <span class="bigger-font margin-small">{{ rider.racePoints.total }} Race Points <span class="smaller-font-4">(Rank: {{ rider.leagueRank }} / {{ rider.totalUsers }})</span></span>
          </div>
          <br>
          <div>
            <fa-icon icon="question-circle" v-tooltip:right="`When you ride on stages, you gain 1 Experience Point (EXP) for every meter of elevation. For example, a race with 452 meters of stages elevation will give you 452 EXP. All your rides are taken into account. You can only gain EXP. The higher your EXP, the higher your level.`" />
            <h4 class="inline margin-small">Level <b-badge pill variant="primary">{{ rider.level }}</b-badge></h4>
            <span class="bigger-font">{{ rider.experiencePoints.total }} EXP <span class="smaller-font-4">(Rank: {{ rider.levelRank }} / {{ rider.totalUsers }})</span></span>
          </div>
          <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="3" cols-xl="3" class="margin">
            <b-col>
            </b-col>
            <b-col>
              <b-progress :max="rider.experiencePointsToReachNextLevel - rider.experiencePointsToReachCurrentLevel" height="25px" show-value striped>
                <b-progress-bar :value="rider.experiencePoints.total - rider.experiencePointsToReachCurrentLevel">
                  <span class="text-black"><strong>{{ rider.experiencePoints.total - rider.experiencePointsToReachCurrentLevel }} / {{ rider.experiencePointsToReachNextLevel - rider.experiencePointsToReachCurrentLevel }} EXP</strong></span>
                </b-progress-bar>
              </b-progress>
              <span class="left-align">Level {{ rider.level }}: {{ rider.experiencePointsToReachCurrentLevel }} EXP</span>
              <span class="right-align">Level {{ rider.level + 1 }}: {{ rider.experiencePointsToReachNextLevel }} EXP</span>
            </b-col>
            <b-col>
            </b-col>
          </b-row>
        </div>
        <span class="failure">{{ failureMessage }}</span>
        <br>
        <div class="text-center">
          <b-row cols="1" cols-sm="1" cols-md="2" cols-lg="2" cols-xl="2">
            <b-col class="margin-top-30">
              <div class="inline">
                <img src="../../public/openseries.png" width="120px">
                <span class="bigger-font-x2">Top Results</span>
              </div>
              <br><br>
              <b-row cols="1" cols-sm="2" cols-md="2" cols-lg="3" cols-xl="3">
                <b-col 
                  v-for="raceAttempt in raceAttempts"
                  :key="raceAttempt.id"
                  class="margin-top-bottom"
                >
                  <router-link class="text-black text-decoration-none" :to="{ name: 'Race', params: { id: raceAttempt.race.id }}">
                    <b-card :img-src="raceAttempt.race.recommendedRoute.stravaDetails.map_urls.url" :img-alt="raceAttempt.race.name" img-top>
                      <b-card-text>
                        <img src="../../public/flag.png" width="25px">&nbsp;
                        <h5 class="inline">{{ raceAttempt.race.name }}</h5>
                        <span v-if="raceAttempt.isEBike">&nbsp;<img src="../../public/thunder.png" width="20px"></span>
                        <br>
                        <br>
                        <h5><b>Race Points:</b> {{raceAttempt.racePoints }}</h5>
                        <h5><b>Rank:</b> {{raceAttempt.rank }} / {{ raceAttempt.race.riders }}</h5>
                      </b-card-text>
                    </b-card>
                  </router-link>
                </b-col>
              </b-row>
              <div class="center-align">
                <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'getRiderRacesRanking', 'riderRacesRankingPagination')"/>
                Page: {{ riderRacesRankingPagination.page }} / {{ riderRacesRankingPagination.totalPages }}
                <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'getRiderRacesRanking', 'riderRacesRankingPagination')"/>
              </div>
            </b-col>
            <b-col class="margin-top-30">
              <div class="inline">
                <img src="../../public/trophyseries.png" width="120px">
                <span class="bigger-font-x2">Top Results</span>
              </div>
              <br><br>
              <b-row cols="1" cols-sm="2" cols-md="2" cols-lg="3" cols-xl="3">
                <b-col 
                  v-for="userTrophyRanking in userTrophiesRanking"
                  :key="userTrophyRanking.id"
                  class="margin-top-bottom"
                >
                  <router-link class="text-black text-decoration-none" :to="{ name: 'Trophy', params: { id: userTrophyRanking.trophy.id }}">
                    <b-card>
                      <b-card-text>
                        <img src="../../public/trophy.png" width="30px">&nbsp;
                        <h5 class="inline">{{ userTrophyRanking.trophy.name }}</h5>
                        <br>
                        <br>
                        <span>Club: {{ userTrophyRanking.trophy.club.name }}</span>
                        <br>
                        <br>
                        <h5><b>Trophy Points:</b> {{userTrophyRanking.points }}</h5>
                        <h5><b>Rank:</b> {{userTrophyRanking.rank }} / {{ userTrophyRanking.trophy.riders }}</h5>
                      </b-card-text>
                    </b-card>
                  </router-link>
                </b-col>
              </b-row>
              <div class="center-align">
                <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'getRiderTrophiesRanking', 'riderTrophiesRankingPagination')"/>
                Page: {{ riderTrophiesRankingPagination.page }} / {{ riderTrophiesRankingPagination.totalPages }}
                <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'getRiderTrophiesRanking', 'riderTrophiesRankingPagination')"/>
              </div>
            </b-col>
          </b-row>
          <br>
          <br>
          <br>
          <br>
          <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="2" cols-xl="2">
            <b-col>
              <div class="text-center"><h4 class="inline">Clubs</h4>&nbsp;&nbsp;(Total: {{ userClubsPagination.count }})</div>
              <b-table :fields="userClubsTable" :items="userClubs" responsive="sm">
                <template #cell(name)="data">
                  <router-link class="text-black" :to="{ name: 'Club', params: { id: data.item.club.id }}">
                    <b>{{ data.item.club.name }}</b>
                  </router-link>
                </template>
                <template #cell(country)="data">
                  {{ data.item.club.country }}
                </template>
                <template #cell(trophies)="data">
                  {{ data.item.club.trophies }}
                </template>
                <template #cell(rank)="data">
                  {{ data.item.rank }} / {{ data.item.club.riders }}
                </template>
                <template #cell(role)="data">
                  {{ data.item.role | capitalize }}
                </template>
                <template #cell(visibility)="data">
                  {{ data.item.isPrivate ? 'Private' : 'Public' }}
                </template>
              </b-table>
              <div class="center-align">
                <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'listUserClubs', 'userClubsPagination')"/>
                  Page: {{ userClubsPagination.page }} / {{ userClubsPagination.totalPages }}
                <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'listUserClubs', 'userClubsPagination')"/>
              </div>
              <br>
              <br>
            </b-col>
            <b-col>
              <div class="text-center"><h4 class="inline">Current trophies</h4>&nbsp;&nbsp;(Total: {{ userComingTrophiesPagination.count }})</div>
              <b-table :fields="userComingTrophiesTable" :items="userComingTrophies" responsive="sm">
                <template #cell(startDate)="data">
                  {{ data.item.trophy.startDate | date }}
                </template>
                <template #cell(endDate)="data">
                  {{ data.item.trophy.endDate | date }}
                </template>
                <template #cell(name)="data">
                  <router-link class="text-black" :to="{ name: 'Trophy', params: { id: data.item.trophy.id }}">
                    <b>{{ data.item.trophy.name }}</b>
                  </router-link>
                </template>
                <template #cell(races)="data">
                  {{ data.item.trophy.races }}
                </template>
                <template #cell(rank)="data">
                  {{ data.item.rank }} / {{ data.item.trophy.riders }}
                </template>
                <template #cell(clubName)="data">
                  <router-link class="text-black" :to="{ name: 'Club', params: { id: data.item.trophy.club.id }}">
                    <b>{{ data.item.trophy.club.name }}</b>
                  </router-link>
                </template>
                <template #cell(visibility)="data">
                  {{ data.item.trophy.isPrivate ? 'Private' : 'Public' }}
                </template>
              </b-table>
              <div class="center-align">
                <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'userComingTrophies', 'userComingTrophiesPagination')"/>
                  Page: {{ userComingTrophiesPagination.page }} / {{ userComingTrophiesPagination.totalPages }}
                <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'userComingTrophies', 'userComingTrophiesPagination')"/>
              </div>
            </b-col>
          </b-row>
          <br>
          <br>
          <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="2" cols-xl="2">
            <b-col>
              <div class="text-center"><h4 class="inline">Races created by user</h4>&nbsp;&nbsp;(Total: {{ userRacesPagination.count }})</div>
              <b-table :fields="userRacesTable" :items="userRaces" responsive="sm">
                <template #cell(createdAt)="data">
                  {{ data.item.createdAt | datetime }}
                </template>
                <template #cell(name)="data">
                  <router-link class="text-black" :to="{ name: 'Race', params: { id: data.item.id }}">
                    <b>{{ data.item.name }}</b>
                    <span v-if="data.item.isEBike">&nbsp;<img src="../../public/thunder.png" width="15px"></span>
                  </router-link>
                </template>
                <template #cell(stages)="data">
                  {{ data.item.itineary | numberOfStages }}
                </template>
                <template #cell(riders)="data">
                  {{ data.item.riders }}
                </template>
                <template #cell(location)="data">
                  {{ data.item.location.city }}, {{ data.item.location.state }}, {{ data.item.location.country }}
                </template>
                <template #cell(validated)="data">
                  {{ data.item.validated | validated }}
                </template>
              </b-table>
              <div class="center-align">
                <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'listUserClubs', 'userClubsPagination')"/>
                  Page: {{ userClubsPagination.page }} / {{ userClubsPagination.totalPages }}
                <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'listUserClubs', 'userClubsPagination')"/>
              </div>
              <br>
              <br>
            </b-col>
            <b-col>
              <div class="text-center"><h4 class="inline">All activities</h4>&nbsp;&nbsp;(Total: {{ allRaceAttemptsPagination.count }})</div>
              <b-table :fields="allRaceAttemptsTable" :items="allRaceAttempts" responsive="sm">
                <template #cell(startDate)="data">
                  {{ data.item.startDate | datetime }}
                </template>
                <template #cell(race)="data">
                  <router-link class="text-black" :to="{ name: 'Race', params: { id: data.item.race.id }}">
                    <b>{{ data.item.race.name }}</b>
                    <span v-if="data.item.isEBike">&nbsp;<img src="../../public/thunder.png" width="15px"></span>
                  </router-link>
                </template>
                <template #cell(activity)="data">
                  <a :href="`https://www.strava.com/activities/${data.item.activity.stravaActivityId}`" target="_blank" class="strava smaller-font">View on Strava</a>
                </template>
              </b-table>
              <div class="center-align">
                <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'listUserRaceAttempts', 'allRaceAttemptsPagination')"/>
                  Page: {{ allRaceAttemptsPagination.page }} / {{ allRaceAttemptsPagination.totalPages }}
                <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'listUserRaceAttempts', 'allRaceAttemptsPagination')"/>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'
  import { PaginationModule } from '../utils.js'

  export default {
    name: 'Rider',
    components: { CButton },
    props: {
      id: String
    },
    data() {
      return {
        failureMessage: '',
        rider: {},
        raceAttempts: [],
        userTrophiesRanking: [],
        riderRacesRankingPagination: {
          page: 1,
          itemsPerPage: 3,
          count: null,
          totalPages: null
        },
        riderTrophiesRankingPagination: {
          page: 1,
          itemsPerPage: 3,
          count: null,
          totalPages: null
        },
        userClubs: [],
        userClubsPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null
        },
        userClubsTable: [
          {
            key: 'name'
          },
          {
            key: 'country'
          },
          {
            key: 'trophies'
          },
          {
            key: 'rank'
          },
          {
            key: 'role'
          },
          {
            key: 'visibility'
          },
        ],
        allRaceAttempts: [],
        allRaceAttemptsPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null
        },
        allRaceAttemptsTable: [
          {
            key: 'startDate',
            label: 'Date'
          },
          {
            key: 'race'
          },
          {
            key: 'activity',
            label: 'Strava activity'
          }
        ],
        userRaces: [],
        userRacesPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null
        },
        userRacesTable: [
          {
            key: 'createdAt',
            label: 'Created on'
          },
          {
            key: 'name'
          },
          {
            key: 'stages',
          },
          {
            key: 'riders',
          },
          {
            key: 'location',
          },
          {
            key: 'validated',
            label: 'Approved'
          },
        ],
        userComingTrophies: [],
        userComingTrophiesPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null
        },
        userComingTrophiesTable: [
          {
            key: 'startDate',
            label: 'Start on'
          },
          {
            key: 'endDate',
            label: 'End on'
          },
          {
            key: 'name'
          },
          {
            key: 'races',
          },
          {
            key: 'rank'
          },
          {
            key: 'clubName',
            label: 'Club'
          },
          {
            key: 'visibility'
          },
        ],
      }
    },
    async created() {
      if (this.$router.currentRoute.meta.requiresAuth && (!this.$store.state.loggedUser || !this.$store.state.loggedUser.email)) this.$router.push({name: 'SignUp'})

      await this.getUser()
      await this.getRiderRacesRanking()
      await this.getRiderTrophiesRanking()
      await this.listUserClubs()
      await this.listUserRaceAttempts()
      await this.listUserRaces()
      await this.listUserComingTrophies()
    },
    mounted() {

    },
    filters: {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
    },
    methods: {
      async getUser() {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getUser.graphql'),
          variables: {
            id: this.id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getUser) {
          this.rider = Object.assign({}, this.rider, result.data.getUser)
        }
      },
      async getRiderRacesRanking() {
        this.failureMessage = ''
        this.raceAttempts = []

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getRiderRacesRanking.graphql'),
          variables: {
            userId: this.id,
            page: this.riderRacesRankingPagination.page,
            itemsPerPage: this.riderRacesRankingPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getRiderRacesRanking) {
          this.raceAttempts = Object.assign({}, this.raceAttempts, result.data.getRiderRacesRanking.raceAttempts)
          this.riderRacesRankingPagination.count = result.data.getRiderRacesRanking.pagination.count
          this.riderRacesRankingPagination.totalPages = result.data.getRiderRacesRanking.pagination.totalPages
        }
      },
      async getRiderTrophiesRanking() {
        this.failureMessage = ''
        this.userTrophiesRanking = []

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getRiderTrophiesRanking.graphql'),
          variables: {
            userId: this.id,
            page: this.riderTrophiesRankingPagination.page,
            itemsPerPage: this.riderTrophiesRankingPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getRiderTrophiesRanking) {
          this.userTrophiesRanking = Object.assign({}, this.userTrophiesRanking, result.data.getRiderTrophiesRanking.usersTrophy)
          this.riderTrophiesRankingPagination.count = result.data.getRiderTrophiesRanking.pagination.count
          this.riderTrophiesRankingPagination.totalPages = result.data.getRiderTrophiesRanking.pagination.totalPages
        }
      },
      async listUserClubs() {
        this.failureMessage = ''
        this.userClubs = []

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/listUserClubs.graphql'),
          variables: {
            userId: this.id,
            page: this.userClubsPagination.page,
            itemsPerPage: this.userClubsPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listUserClubs) {
          this.userClubs.push(...result.data.listUserClubs.userClubs)
          this.userClubsPagination.count = result.data.listUserClubs.pagination.count
          this.userClubsPagination.totalPages = result.data.listUserClubs.pagination.totalPages
        }
      },
      async listUserRaceAttempts() {
        this.failureMessage = ''
        this.allRaceAttempts = []

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/listUserRaceAttempts.graphql'),
          variables: {
            userId: this.id,
            page: this.allRaceAttemptsPagination.page,
            itemsPerPage: this.allRaceAttemptsPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listUserRaceAttempts) {
          this.allRaceAttempts.push(...result.data.listUserRaceAttempts.raceAttempts)
          this.allRaceAttemptsPagination.count = result.data.listUserRaceAttempts.pagination.count
          this.allRaceAttemptsPagination.totalPages = result.data.listUserRaceAttempts.pagination.totalPages
        }
      },
      async listUserRaces() {
        this.failureMessage = ''
        this.userRaces = []

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/listUserRaces.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            userId: this.id,
            page: this.userRacesPagination.page,
            itemsPerPage: this.userRacesPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listUserRaces) {
          this.userRaces.push(...result.data.listUserRaces.races)
          this.userRacesPagination.count = result.data.listUserRaces.pagination.count
          this.userRacesPagination.totalPages = result.data.listUserRaces.pagination.totalPages
        }
      },
      async listUserComingTrophies() {
        this.failureMessage = ''
        this.userComingTrophies = []

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/listUserComingTrophies.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            userId: this.id,
            page: this.userComingTrophiesPagination.page,
            itemsPerPage: this.userComingTrophiesPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listUserComingTrophies) {
          this.userComingTrophies.push(...result.data.listUserComingTrophies.usersTrophy)
          this.userComingTrophiesPagination.count = result.data.listUserComingTrophies.pagination.count
          this.userComingTrophiesPagination.totalPages = result.data.listUserComingTrophies.pagination.totalPages
        }
      },
      pagination(type, funcToExecute, obj) {
        const paginationModule = PaginationModule();
        const newPage = paginationModule.changePage(type, this[obj].page, this[obj].totalPages);
        if (newPage) {
          this[obj].page = newPage;
          this[funcToExecute](this[obj].payload);
        }
      },
    }
  }
</script>

<style scoped>

</style>
